/** localStorage ключи для табличных фильтров. */

export const PROJECT_TABLE_FILTERS_ENABLED_KEY = 'project-table-filters-enabled';
export const PROJECT_TABLE_FILTERS_KEY = 'project-table-filters';

export const READERS_CATALOG_FILTERS_ENABLED_KEY = 'readers-catalog-filters-enabled';
export const READERS_CATALOG_FILTERS_KEY = 'readers-catalog-filters';
